import { useState, createContext, useEffect } from "react";
import useAuthenticatedFetchData from "../../src/services/hooks";

export const AppContext = createContext();

const ContextProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [fetchData, setFetchData] = useState(null);
  const [fetchLoading, setFetchLoading] = useState(null);
  const [fetchError, setFetchError] = useState(null);
  // const [dataRange, setDataRange] = useState("All");
  const [fromDate, setFromDate] = useState("All");
  const [toDate, setToDate] = useState("");
  // const [firstDate, setFirstDate] = useState("");
  // const [lastDate, setLastDate] = useState("");
  const [clearState, setClearState] = useState("");

  const { data, loading, error } = useAuthenticatedFetchData(
    fromDate,
    toDate,
    isAuthenticated
  );

  // console.log(data);

  // Update fetch data only when authenticated
  useEffect(() => {
    if (isAuthenticated) {
      setFetchData(data);
      setFetchLoading(loading);
      setFetchError(error);
    }
  }, [isAuthenticated, data, loading, error]);

  return (
    <AppContext.Provider
      value={{
        isAuthenticated,
        setIsAuthenticated,
        fetchData,
        fetchLoading,
        fetchError,
        fromDate,
        setFromDate,
        toDate,
        setToDate,
        data,
        error,

        clearState,
        setClearState,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default ContextProvider;
